import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, nextTick, onUnmounted } from "vue";
import { trans } from "laravel-vue-i18n";


export default /*#__PURE__*/_defineComponent({
  emits: ["submit", "back", "mounted"],
  setup(__props, { expose, emit }) {
  expose();

const component = ref<HTMLDivElement>();



onMounted(async () => {
    await nextTick();

    const updateHeight = () => {
        if (component.value) {
            const height = component.value.getBoundingClientRect().height;
            emit("mounted", height);
        }
    };

    updateHeight();

    const resizeObserver = new ResizeObserver(() => {
        updateHeight();
    });

    if (component.value) {
        resizeObserver.observe(component.value);
    }

    window.addEventListener("resize", updateHeight);
    window.addEventListener("orientationchange", updateHeight);

    // Clean up
    onUnmounted(() => {
        if (component.value) {
            resizeObserver.unobserve(component.value);
        }
        window.removeEventListener("resize", updateHeight);
        window.removeEventListener("orientationchange", updateHeight);
    });

    // scroll to top
    window.scrollTo(0, 0);
});

const __returned__ = { component, emit, trans }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})